const createState = () => ({
  unused: new Map(),
  used: new Set(),
  provided: new Set()
});
export const stats = {
  state: createState(),
  set(injObj) {
    var _injObj$value;
    // allow injectable override without flagging as unused
    for (let unusedInj of this.state.unused.keys()) if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
    this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
      cause: injObj.cause
    }));
    // reset to avoid potential memory leaks via stack traces
    injObj.cause = null;
  },
  track(inj) {
    if (!inj) return;
    this.state.unused.delete(inj);
    this.state.used.add(inj);
    this.state.provided.add(inj.from);
  },
  reset() {
    this.state = createState();
  },
  unused() {
    return Array.from(this.state.unused.entries()).map(([inj, error]) => ({
      get: () => inj.value,
      error: () => error
    }));
  }
};